import type { ModuleProperties } from "~api/module";

const permissions: ModuleProperties = {
  functionName: "getPermissions",
  permissions: [],
};

export default permissions;
